import styled from 'styled-components/macro';

export const PageContent = styled.div`
	margin-left: 22px;
	margin-right: 22px;
`;
